import React from "react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import InputText from "../Input/InputText";
import EditorText from "../EditorText";
import "../../../assets/style/modalStyle/postNews.scss";

import LabelInput from "../LabelInput";
import UpImageEdit from "../Button/UpImageEdit";
import SelectValue from "../Selector/SelectValue";
import { valueSelectCategorieNews } from "../../../utils/ValueSelect";
import TranslateText from "../TranslateText";
import UploadImage from "../Button/UploadImage";

const TabAddNews = ({ datapost, setDataPost, setImage, error, img }) => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col span={2}>
          <LabelInput text={"Tiêu đề"} align={"middle"} />
        </Col>
        <Col span={22}>
          <InputText
            maxLength={155}
            text={datapost.title}
            setText={(value) => setDataPost({ ...datapost, title: value })}
            placeholder={"Nhập tiêu đề bài viết"}
            typeInput={`${
              !datapost.title && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      <Row style={{ margin: "1.5rem 0" }} align={"middle"}>
        <Col span={2}>
          <LabelInput text={"Mô tả"} />
        </Col>
        <Col span={22}>
          <InputText
            text={datapost.descriptions}
            setText={(value) =>
              setDataPost({ ...datapost, descriptions: value })
            }
            placeholder={"Nhập mô tả"}
            typeInput={`${
              !datapost.descriptions && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "1.5rem" }}>
        <Col
          span={2}
          style={{
            display: "flex",
            alignItems: datapost.typePost === 1 ? "" : "center",
          }}
        >
          <LabelInput
            text={datapost.typePost === 1 ? "Nội dung" : "Link bài viết"}
          />
        </Col>
        <Col span={22}>
          {datapost.typePost === 1 ? (
            <EditorText
              height={300}
              placeholder={"Nhập nội dung bài viết"}
              setText={setDataPost}
              type={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : null
              }`}
            />
          ) : (
            <InputText
              text={datapost.content}
              setText={(value) => setDataPost({ ...datapost, content: value })}
              placeholder={"Nhập đường dẫn bài viết"}
              typeInput={`${
                (!datapost.content && error.isError) ||
                error.msg === "Đường dẫn không hợp lệ"
                  ? "checkEmptyText"
                  : null
              }`}
            />
          )}
        </Col>
      </Row>
      <Row justify={"end"}>
        <Col span={22}>
          <Row>
            <Col span={4}>
              <LabelInput text={"Ảnh ở giao diện bên ngoài"} />
            </Col>
            <Col span={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // justifyContent: "center",
                  width: "160px",
                  alignItems: "center",
                }}
              >
                <UploadImage
                  isCropImage={false}
                  setImage={setImage}
                  width={"160px"}
                  height={"110px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={img}
                  setDataPost={setDataPost}
                  widthImage={524}
                  heightImage={320}
                  url={datapost.firstImage}
                  setFile={(value) => {
                    setDataPost({ ...datapost, largeImage: value });
                  }}
                  style={
                    datapost && !img && error.isError
                      ? { border: "1px solid red" }
                      : null
                  }
                />
                <span className="noteSize">
                  (<TranslateText text={"Kích thước"} /> ảnh gốc)
                </span>
              </div>
            </Col>
            <Col span={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "160px",
                  // justifyContent: "center",
                  // border: "1px solid",
                  alignItems: "center",
                }}
              >
                <UpImageEdit
                  setImage={setImage}
                  width={"160px"}
                  height={"110px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={img}
                  setDataPost={setDataPost}
                  widthImage={352}
                  heightImage={198}
                  url={datapost.secondImage}
                  setFile={(value) => {
                    setDataPost({ ...datapost, smallImage: value });
                  }}
                  style={
                    datapost && !img && error.isError
                      ? { border: "1px solid red" }
                      : null
                  }
                />
                <span className="noteSize">
                  (<TranslateText text={"Kích thước"} /> 352x198)
                </span>
              </div>
            </Col>
            <Col span={3}>
              <LabelInput text={"Loại tin tức"} />
            </Col>
            <Col span={2}>
              <SelectValue
                type={"selectGray base"}
                handleChange={(value) =>
                  setDataPost((pre) => ({ ...pre, categories: value }))
                }
                optionsValue={valueSelectCategorieNews}
                defaultValue={"Tin tức"}
                width={166}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {error.isError ? (
        <small className="msgError">{t(error.msg)}</small>
      ) : null}
    </>
  );
};

export default TabAddNews;
